import Header from '../components/Layout/Header.jsx';
import Footer from '../components/Layout/Footer.jsx';
import ProductGrid from '../components/Product/ProductGrid.jsx';
import CartDrawer from '../components/Cart/CartDrawer.jsx';

export default function Shop() {
    return (
    <>
        <Header/>
        <ProductGrid/>
        <CartDrawer/>
        <Footer/>
    </>
    )
}